import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './TemplatesTypes.css';

const agentTemplates = [
    { id: 'agent-base', title: 'Base', description: 'A solid foundation with essential features and a clean design.', img: require('../../assets/imgs/previews/agent/base.jpg') },
    { id: 'agent-luxury', title: 'Luxury', description: 'Elegant and sophisticated with high-quality visuals.', img: require('../../assets/imgs/previews/agent/luxury.jpg') },
    { id: 'agent-metropolitan', title: 'Metropolitan', description: 'Modern living with neutral tones and refined visuals.', img: require('../../assets/imgs/previews/agent/metropolitan.jpg') },
    { id: 'agent-skyline', title: 'Skyline', description: 'Condo-focused theme with high-rise and city views.', img: require('../../assets/imgs/previews/agent/skyline.jpg') },
    { id: 'agent-vibrance', title: 'Vibrance', description: 'Energetic, bold, and full of life.', img: require('../../assets/imgs/previews/agent/vibrance.jpg') },
    { id: 'agent-futuristic', title: 'Futuristic', description: 'High-tech aesthetics with vibrant neon and abstract visuals.', img: require('../../assets/imgs/previews/agent/futuristic.jpg') },
];

const getMobileImg = (img) => {
    // img example: ../../assets/imgs/previews/agent/base.jpg
    // want: ../../assets/imgs/previews/mobile/agent/base.jpg
    if (!img || typeof img !== "string") return img;
    return img.replace('/previews/agent/', '/previews/mobile/agent/');
};

const AgentTemplates = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [sortOrder, setSortOrder] = useState('az');

    let filteredTemplates = agentTemplates.filter(template =>
        template.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        template.description.toLowerCase().includes(searchQuery.toLowerCase())
    );

    if (sortOrder === 'az') {
        filteredTemplates = filteredTemplates.sort((a, b) => a.title.localeCompare(b.title));
    } else if (sortOrder === 'za') {
        filteredTemplates = filteredTemplates.sort((a, b) => b.title.localeCompare(a.title));
    }

    return (
        <>
            <Helmet>
                <title>Agent Website Templates | AptoWebsites</title>
                <meta name="description" content="Explore modern, customizable website templates for real estate agents. Mobile-optimized, SEO-friendly, and easy to use." />
                <meta name="keywords" content="agent website templates, real estate agent templates, mobile, SEO, AptoWebsites" />
                <meta property="og:title" content="Agent Website Templates | AptoWebsites" />
                <meta property="og:description" content="Explore modern, customizable website templates for real estate agents. Mobile-optimized, SEO-friendly, and easy to use." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/agent-templates" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/agent-templates" />
            </Helmet>
            <div className="templatebackground">
                <div className="template-header-bar professional">
                    <div className="template-header-titles">
                        <h1 className="template-header-title">Agent Website Templates</h1>
                            {/* <p className="template-header-subtitle">
                                Modern, mobile-friendly, and conversion-focused templates for real estate professionals.
                            </p> */}
                    </div>
                    <div className="template-header-controls">
                        <div className="template-sort-group">
                            <label htmlFor="template-sort" className="template-sort-label">Sort:</label>
                            <select
                                id="template-sort"
                                className="template-sort-select"
                                value={sortOrder}
                                onChange={e => setSortOrder(e.target.value)}
                            >
                                <option value="az">A-Z</option>
                                <option value="za">Z-A</option>
                            </select>
                        </div>
                        <div className="template-search-group">
                            <svg className="search-icon" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                <circle cx="9" cy="9" r="7" stroke="#0d47a1" strokeWidth="2"/>
                                <line x1="14.4142" y1="14" x2="18" y2="17.5858" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            <input
                                type="text"
                                placeholder="Search templates..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="filter-input template-search-input"
                            />
                        </div>
                    </div>
                </div>
                <div className="template-section">
                    <div className="template-list">
                        {filteredTemplates.map(template => {
                            let mobileImgSrc;
                            try {
                                mobileImgSrc = require(`../../assets/imgs/previews/mobile/agent/${template.id.replace('agent-', '')}.jpg`);
                            } catch (e) {
                                mobileImgSrc = template.img; // fallback
                            }
                            return (
                                <Link to={`/${template.id}`} key={template.id} className="template-box">
                                    <div className="template-img-wrapper overlap">
                                        <img src={template.img} alt={template.title} className="template-img main-img" />
                                        <div className="phone-mockup-container overlap">
                                            <img
                                                src={require('../../assets/imgs/mockups/phone-mockup-transparent.png')}
                                                alt="Phone Mockup"
                                                className="phone-mockup-img"
                                            />
                                            <img
                                                src={mobileImgSrc}
                                                alt={`${template.title} mobile`}
                                                className="template-img phone-inside-img"
                                            />
                                        </div>
                                    </div>
                                    <div className="template-info">
                                        <h3>{template.title}</h3>
                                        <p>{template.description}</p>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

export default AgentTemplates;
